import { APIS, TENANT_ID } from "../../../../utils/api-factory"
import { TENANT_HEADER } from "../../../../utils/apiHeaders"

export const getApiOverallSummaryByDateStatus = (sDate,eDate,loanStatus, apiId, callBack) => {
  fetch(APIS.GET_API_OVERALL_SUMMARY_BY_DATE_STATUS + sDate + "&endDate=" + eDate + "&loanStatus=" + loanStatus + "&apiId=" + apiId,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getApicostSummaryByFilters = (sDate,eDate, apiId, callBack) => {
  fetch(APIS.GET_API_COST_SUMMARY_BY_FILTERS + sDate + "&endDate=" + eDate  + "&apiId=" + apiId,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getApicostSummaryHitsByFilters = (sDate,eDate,loanStatus, apiId, callBack) => {
  fetch(APIS.GET_API_COST_SUMMARY_HITS_BY_FILTERS + sDate + "&endDate=" + eDate + "&loanStatus=" + loanStatus  + "&apiId=" + apiId,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getApiHitTrendByDataRangeApiId = (sDate,eDate,type, apiId, callBack) => {
  fetch(APIS.GET_API_HIT_TRENDS_BY_DATA_RANGE_APIID + sDate + "&endDate=" + eDate + "&dateType=" + type + "&apiId=" + apiId,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getThirdPartyApiListByData = (callBack) => {
  fetch(APIS.GET_THIRD_PARTY_API_LIST_BY_DATA,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getThirdPartyApiListcategoryWiseByData = (callBack) => {
  fetch(APIS.GET_THIRD_PARTY_API_LIST_CATEGORY_WISE_BY_DATA,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getLeadDisbursmentFunnelByDaterange = (sDate,eDate,callBack) => {
  fetch(APIS.GET_LEAD_TO_DISBURSMENT_FUNNEL_BY_DATA_RANGE + sDate + "&endDate=" + eDate,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}


export const getUserDataByDateRangeAndApiId = (page , size ,sDate,eDate,apiId, callBack) => {
  fetch(APIS.GET_USER_DATA_BY_DATE_RANGE + page + "&size=" + size + "&startDate="+ sDate + "&endDate=" + eDate + "&apiId=" + apiId,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getAPiOverallSummaryFormStatusByDate = (sDate,eDate,apiId, callBack) => {
  fetch(APIS.GET_API_OVERALL_SUMMARY_FORM_STATUS_BY_DATE + sDate + "&endDate=" + eDate + "&apiId=" + apiId,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}

export const downloadUserDataByDateRangeAndApiId = (sDate,eDate,apiId, callBack) => {
  fetch(APIS.DOWNLOAD_USER_DATA_BY_DATE_RANGE + sDate + "&endDate=" + eDate + "&apiId=" + apiId,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}

export const getLeadFunnelByDateRange = (sDate,eDate, callBack) => {
  fetch(APIS.GET_LEAD_FUNNEL_BY_DATE_RANGE + sDate + "&endDate=" + eDate,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}

export const getSanctionTrendDataByDateRange = (sDate,eDate,dateType , callBack) => {
  fetch(APIS.GET_SANCTION_TREND_DATA_BY_DATE_RANGE + sDate + "&endDate=" + eDate + "&dateType=" + dateType,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getSanctionStatsByDateRange = (sDate,eDate, callBack) => {
  fetch(APIS.GET_SANCTION_STATS_DATA_BY_DATE + sDate + "&endDate=" + eDate,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getSanctionLeadsByDateRange = (sDate,eDate, pageNumber , size , callBack) => {
  fetch(APIS.GET_SANCTION_LEADS_BY_DATE_RANGE + sDate + "&endDate=" + eDate + "&page=" + pageNumber + "&size=" + size,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}

export const getDisbursedTrendDataByDateRange = (sDate,eDate,dateType , callBack) => {
  fetch(APIS.GET_DISBURSED_TREND_DATA_BY_DATE_RANGE + sDate + "&endDate=" + eDate + "&dateType=" + dateType,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getDisbursedStatsByDateRange = (sDate,eDate, callBack) => {
  fetch(APIS.GET_DISBURSED_STATS_DATA_BY_DATE + sDate + "&endDate=" + eDate,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getDisbursedLeadsByDateRange = (sDate,eDate, pageNumber , size , callBack) => {
  fetch(APIS.GET_DISBURSED_LEADS_BY_DATE_RANGE + sDate + "&endDate=" + eDate + "&page=" + pageNumber + "&size=" + size,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}

export const downloadSanctionedDataByDateRange = (sDate, eDate, callBack) => {
  fetch(
    APIS.DOWNLOAD_SANCTION_APPROVED_DATA_BY_DATE_RANGE +
      sDate +
      "&endDate=" +
      eDate,TENANT_HEADER
  )
    .then((res) => res.blob())
    .then((blob) => {
      callBack(blob);
    });
};

export const downloadDisbursedDataByDateRange = (sDate, eDate, callBack) => {
  fetch(
    APIS.DOWNLOAD_DISBURSED_DATA_BY_DATE_RANGE + sDate + "&endDate=" + eDate,TENANT_HEADER
  )
    .then((res) => res.blob())
    .then((blob) => {
      callBack(blob);
    });
};

export const getApiOverviewLeadJourneyFunnelByDateRange = (
  sDate,
  eDate,
  callBack,
) => {
  fetch(
    APIS.GET_API_OVERVIEW_LEAD_JOURNEY_BY_DATE_RANGE +
      sDate +
      "&endDate=" +
      eDate,
      TENANT_HEADER
  )
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    });
};

export const getApiOverviewLeadLeakageInsightsByDateRange = (
  sDate,
  eDate,
  callBack,
) => {
  fetch(
    APIS.GET_API_OVERVIEW_LEAD_LEAKAGE_INSIGHTS_BY_DATE_RANGE +
      sDate +
      "&endDate=" +
      eDate,
      TENANT_HEADER
  )
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    });
};

export const getLeadJourneyDropOutCustomerReason = (
  startDate,
  endDate,
  currentStage,
  nextStage,
  reason,
  page,
  size,
  callBack,
) => {
  const url =
    `${APIS.GET_LEAD_JOURNEY_DROP_OUT_COUSTOMER_REASON}${startDate}` +
    `&endDate=${endDate}&currentStage=${currentStage}&nextStage=${nextStage}&reason=${reason}&page=${page}&size=${size}`;

  fetch(url,TENANT_HEADER)
    .then((res) => res.json())
    .then((json) => callBack(json));
};
export const downloadLeadJourneyDropOutCustomerReason = (
  startDate,
  endDate,
  currentStage,
  nextStage,
  reason,
  callBack,
) => {
  const url =
    `${APIS.DOWNLOAD_LEAD_JOURNEY_DROP_OUT_COUSTOMER_REASON}${startDate}` +
    `&endDate=${endDate}&currentStage=${currentStage}&nextStage=${nextStage}&reason=${reason}`;

  fetch(url,TENANT_HEADER)
   .then((res) => res.blob())
    .then((json) => callBack(json));
};
export const getLeadJourneyDropOutAnalysis = (
  startDate,
  endDate,
  currentStage,
  nextStage,
  callBack,
) => {
  const url =
    `${APIS.GET_LEAD_JOURNEY_DROP_OUT_ANALYSIS}${startDate}` +
    `&endDate=${endDate}&currentStage=${currentStage}&nextStage=${nextStage}`;

  fetch(url,TENANT_HEADER)
    .then((res) => res.json())
    .then((json) => callBack(json));
};
export const getLeadJourneyStageAnalysis = (
  startDate,
  endDate,
  currentStage,
  nextStage,
  callBack,
) => {
  const url =
    `${APIS.GET_LEAD_JOURNEY_STAGE_ANALYSIS}${startDate}` +
    `&endDate=${endDate}&currentStage=${currentStage}&nextStage=${nextStage}`;

  fetch(url,TENANT_HEADER)
    .then((res) => res.json())
    .then((json) => callBack(json));
};
export const getDropOfListLeadByFilters = (
  stage,
  startDate,
  endDate,
  currentStage,
  count,
  callBack,
) => {
  const url =
    `${APIS.GET_DROP_OFF_LEAD_LIST_BY_FILTERS}${stage}` +
    `&startDate=${startDate}&endDate=${endDate}&pageNo=${currentStage}&count=${count}`;

  fetch(url,TENANT_HEADER)
    .then((res) => res.json())
    .then((json) => callBack(json));
};
